import React from "react";
import { GoogleLogin } from "react-google-login";
import { GoogleAuthProvider, getAuth, signInWithCredential, signOut } from "firebase/auth";
import { appState } from "../globalState";
import getFirebase, { getDbInterfaceAuth } from "../firebase";
import { AUTHENTICATION_SCOPES } from "./utils/apiTarget";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const COMPANY_EMAIL_DOMAIN = "@tulu.io";
const COMPANY_HOSTED_DOMAIN = "tulu.io";

// `authenticationScope`: "default" signs into the app-wide Firebase Auth (Printer dashboard,
// remembered across tabs and restarts); "dbInterface" signs into the per-tab DB Interface
// session and never caches the user in localStorage.
// `forceAccountChooser`: always show Google's account picker, so every DB Interface entry is
// a deliberate sign-in rather than a silent reuse of the last account.
const GoogleBtn = ({
  isSuccess,
  authenticationScope = AUTHENTICATION_SCOPES.default,
  forceAccountChooser = false,
}) => {
  const selectAuth = () =>
    authenticationScope === AUTHENTICATION_SCOPES.dbInterface
      ? getDbInterfaceAuth()
      : getAuth(getFirebase());

  const handleLoginFailure = (response) => {
    console.log(response);
    alert("Failed to log in");
  };

  const login = async ({ tokenId, accessToken }) => {
    if (!(accessToken && tokenId)) return;

    const auth = selectAuth();
    const credential = GoogleAuthProvider.credential(tokenId, accessToken);
    const userCredential = await signInWithCredential(auth, credential);
    const user = userCredential.user.toJSON();
    const email = user.providerData?.[0]?.email;
    const isCompanyAccount =
      process.env.NODE_ENV === "development"
        ? true
        : Boolean(email && email.endsWith(COMPANY_EMAIL_DOMAIN));

    if (isCompanyAccount) {
      setTimeout(() => {
        appState.email = email;
        if (authenticationScope === AUTHENTICATION_SCOPES.default) {
          localStorage.setItem("user", JSON.stringify(user));
        }
        isSuccess(user);
      });
    } else {
      localStorage.removeItem("user");
      await signOut(auth);
    }
  };

  return (
    <div>
      <GoogleLogin
        clientId={CLIENT_ID}
        buttonText="Login"
        onSuccess={login}
        onFailure={handleLoginFailure}
        cookiePolicy={"single_host_origin"}
        responseType="code,token"
        hostedDomain={process.env.NODE_ENV === "development" ? undefined : COMPANY_HOSTED_DOMAIN}
        prompt={forceAccountChooser ? "select_account" : undefined}
      />
    </div>
  );
};

export { GoogleBtn };
